import { Actions, LalSegmentFields, type LalSegmentFormState, type SeedListData } from '@openx/types/segments.ts';
import { useCallback, useReducer } from 'react';
import { useFormContext } from 'react-hook-form';
import { addItem } from './utils/addItem.ts';
import { getInitialData } from './utils/getInitialData.ts';
import { reducerSeedList } from './utils/reducerSeedList.ts';

export const useHandleState = () => {
  const { getValues, setValue } = useFormContext<LalSegmentFormState>();

  const initState = getInitialData(getValues(LalSegmentFields.SEEDS) ?? []);
  const [state, dispatch] = useReducer(reducerSeedList, initState);

  const handleAddItem = useCallback(
    (item?: SeedListData) => {
      if (!item) return;

      const updatedValue = addItem({ ...item, isOnList: true }, getValues(LalSegmentFields.SEEDS) ?? [], dispatch);

      setValue(LalSegmentFields.SEEDS, updatedValue, { shouldDirty: true, shouldValidate: true });
    },
    [getValues, setValue]
  );

  const handleRemoveItem = useCallback(
    (item: SeedListData) => {
      const filteredListData = state.listData.filter(listItem => listItem.id !== item.id);
      setValue(LalSegmentFields.SEEDS, filteredListData, { shouldDirty: true, shouldValidate: true });
      dispatch({ type: Actions.SET_LIST_DATA, payload: filteredListData });
    },
    [setValue, state.listData]
  );

  const handleRemoveAll = useCallback(() => {
    setValue(LalSegmentFields.SEEDS, [], { shouldDirty: true, shouldValidate: true });
    dispatch({ type: Actions.SET_LIST_DATA, payload: [] });
  }, [setValue]);

  return { state, dispatch, handleAddItem, handleRemoveItem, handleRemoveAll };
};
